<template lang="pug">
.float(:class="{ open: isFloatOpen }")
  .float-btn(@click="isFloatOpen = !isFloatOpen")
    a(style="cursor: pointer")
      font-awesome-icon(
        :icon="['far', 'question-circle']",
        style="margin-right: 0.35rem"
      )
  a.btn-link(
    v-b-modal.messageModal="",
    @click="$bvModal.show('messageModal')",
    data-toggle="modal",
    data-target="#messageModal"
  )
    font-awesome-icon(
      :icon="['fas', 'comments']",
      style="width: 21.61px; height: 19px"
    )
    small Message

  a.btn-link(style="cursor: pointer", @click="toSupportCenter")
    i.fas.fa-cogs
    font-awesome-icon(
      :icon="['fas', 'cogs']",
      style="width: 24px; height: 19px"
    )
    small Support
</template>

<script>
export default {
  name: "FloatActions",
  data() {
    return {
      isFloatOpen: false,
    };
  },
  methods: {
    toSupportCenter() {
      this.$router.push({
        name: "SupportCenter",
      });
    },
  },
};
</script>
<style scoped lang="scss">
@keyframes float-open {
  from {
    right: -60px;
    opacity: 0;
  }
  to {
    right: 0px;
    opacity: 1;
  }
}

@keyframes float-close {
  from {
    right: 0px;
    opacity: 0;
  }
  to {
    right: -60px;
    opacity: 1;
  }
}

.float {
  position: fixed;
  top: 70%;
  width: 60px;
  height: 113px;
  margin-top: -51.5px;
  background: #faad00;
  text-align: center;
  padding: 5px;
  border-radius: 0.3rem 0 0 0.3rem;
  z-index: 99;
  animation-name: float-close;
  animation-duration: 0.3s;
  animation-fill-mode: forwards;

  .float-btn {
    position: absolute;
    width: 35px;
    left: -35px;
    top: 50%;
    padding: 10px 5px;
    background: #faad00;
    border-radius: 50% 0 0 50%;
    line-height: 25px;
    margin-top: -17.5px;

    a {
      color: white;
      margin-left: 5px;
    }
  }

  .btn-link {
    display: block;
    background-color: rgba(0, 0, 0, 0.1);
    color: white;
    border-radius: 0.3rem;
    margin-bottom: 0.4rem;
    padding: 0.4rem 0;
    text-decoration: none;
    transition: all 0.3s;
    transition: all 0.3s;

    &:hover {
      background-color: #082b6b;
      color: white;
    }

    svg {
      width: 1.2rem;
      height: 1.2rem;
    }

    small {
      display: block;
      font-size: 10px;
      transform: scale(0.85);
      line-height: 1;
      font-weight: 300;
    }
  }
}

.float.open {
  animation-name: float-open;
  animation-duration: 0.3s;
  animation-fill-mode: forwards;
}
</style>
